import type { CompleteSuccessStory } from '../../types';
import { Check } from 'lucide-react';

interface CtaSectionProps {
  story: CompleteSuccessStory;
}

export function CtaSection({ story }: CtaSectionProps) {
  return (
    <section className="py-20 lg:py-32 bg-card">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-primary to-secondary rounded-3xl p-12 lg:p-16 text-primary-foreground text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-1/3 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <h2 className="font-bold text-4xl lg:text-5xl mb-6">
              Ready to Transform Your Portfolio Management?
            </h2>
            <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
              See how Planisware can deliver similar results for your organization. Schedule a
              personalized demo with our enterprise solutions team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button className="bg-accent text-accent-foreground px-10 py-5 rounded-xl font-bold text-lg hover:opacity-90 transition-opacity shadow-2xl">
                Schedule Your Demo
              </button>
              <button className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-white/20 transition-colors border-2 border-white/30">
                Download Case Study PDF
              </button>
            </div>
            <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-sm text-white/60">
              <div className="flex items-center gap-2">
                <Check className="w-5 h-5" />
                <span>No credit card required</span>
              </div>
              <div className="flex items-center gap-2">
                <Check className="w-5 h-5" />
                <span>Free 30-day trial available</span>
              </div>
              <div className="flex items-center gap-2">
                <Check className="w-5 h-5" />
                <span>Dedicated success manager</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
